var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 59 56"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m39.467 16.853 19.2 4.48-13.014 14.934 1.707 19.626-18.133-7.68-18.134 7.68L12.8 36.267 0 21.333l18.987-4.48L29.227 0zm9.386 7.68-12.8-2.986-6.826-11.307L22.4 21.547 9.813 24.533l8.534 10.027-1.067 13.013 11.947-5.12 12.16 5.12-1.28-13.013z"
  })));
};
export default SvgStar;